import { useDispatch } from "react-redux";
import { setContextMenu } from "../../../abstract/redux/slice/overlaySlice";
import styles from "./Aside.module.scss";



function Aside({ showAside, primary, children }) {
  const _dispatch = useDispatch();

  const handleOnScroll = () => {
    _dispatch(setContextMenu(""))
  }

  return (
    <div className={`${styles["back"]} ${styles[`back--${primary ? "left" : "right"}`]}`} onScroll={handleOnScroll
      
    }>
      <div className={`${styles["aside"]} ${!showAside ? styles["aside--hidden"] : ""}`} onScroll={handleOnScroll}>
        {children}
      </div>
    </div>
  );
}

export default Aside;
